import React from 'react'
import { useTranslation } from 'react-i18next'
import { renderBrandMarkup } from '../utils/security'

export default function Main() {
  const {t} = useTranslation()
  return (
    <div className='main'>
     
     <div className='main_text'>
          <h1>{renderBrandMarkup(t("brand"))}</h1>
        </div>
        <div className='main_img'></div>
      
    </div>
  )
}
